import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { SIcon, SInput } from '@strana-artw/ui-kit';
import { defineComponent, onBeforeUnmount, ref, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'EditableTitle',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  emits: ["update:title"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    defineComponent({
      name: 'EditableTitle'
    });
    var collectionTitle = ref('');
    watch(function () {
      return props.title;
    }, function (value) {
      collectionTitle.value = value;
    });
    var editEnabled = ref(false);
    function handlerEditedTitle() {
      editEnabled.value = true;
    }
    var changingTitle = ref(false);
    var timer = ref();
    function handlerChangeTitle() {
      return _handlerChangeTitle.apply(this, arguments);
    }
    function _handlerChangeTitle() {
      _handlerChangeTitle = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (changingTitle.value) {
                _context.next = 1;
                break;
              }
              changingTitle.value = true;
              _context.next = 1;
              return emit('update:title', collectionTitle.value);
            case 1:
              timer.value = setTimeout(function () {
                changingTitle.value = false;
              }, 1000);
              editEnabled.value = false;
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _handlerChangeTitle.apply(this, arguments);
    }
    onBeforeUnmount(function () {
      clearTimeout(timer.value);
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      collectionTitle: collectionTitle,
      editEnabled: editEnabled,
      handlerEditedTitle: handlerEditedTitle,
      changingTitle: changingTitle,
      timer: timer,
      handlerChangeTitle: handlerChangeTitle,
      SIcon: SIcon,
      SInput: SInput
    };
  }
});